import React, {useContext} from 'react';
import {CombinedGraphQLErrors} from '@apollo/client';

import {Seo} from './seo';
import {SITE_NAME} from './site';

/**
 * Статус ответа, который выясняется только при серверном рендере — например, что сущности
 * с таким id нет. withApolloClient кладёт объект в контекст на время getDataFromTree,
 * карточки отмечают в нём «не найдено», и сервер отдаёт 404 вместо «мягкой» 200.
 */
export type SsrStatus = {notFound?: boolean};

const SsrStatusContext = React.createContext<SsrStatus | null>(null);

export const SsrStatusProvider = SsrStatusContext.Provider;

export function useNotFound(notFound: boolean) {
	const status = useContext(SsrStatusContext);
	// объект живёт один запрос и только на сервере, поэтому запись во время рендера безопасна
	if (status && notFound) status.notFound = true;
}

/**
 * Одиночные запросы в API объявлены не-null, поэтому отсутствующая сущность приходит
 * GraphQL-ошибкой. Сетевую ошибку (API недоступен) за «не найдено» не считаем.
 */
export function isNotFoundError(error: unknown): boolean {
	return !!error && CombinedGraphQLErrors.is(error as Error);
}

export const NotFoundSeo: React.FC = () => (
	<Seo title={`Страница не найдена — ${SITE_NAME}`} description="Такой страницы на сайте нет." noindex />
);
